import { AuxiliumComponent } from "../auxilium-component";

export default class Label extends AuxiliumComponent {
	static observable = ["type", "for", "size"];

	constructor() {
		super();

		if (this.type === "secondary") {
			this.classList.add("input-field__helper-text");
		} else {
			this.classList.add("input-field__label");
		}
	}

	parsedCallback() {
		const element = document.createElementWithContents(this.for ? "label" : "span", this.childNodes);

		if (this.for) {
			const forTarget = document.getElementById(this.for);

			if (forTarget?.matches("chip-input, chip-checkbox, chip-textarea, chip-radio, chip-colourpicker, chip-button")) {
				element.htmlFor = forTarget.identifier;
			} else {
				element.htmlFor = this.for;
			}
		}

		this.appendChild(element);
	}
}
